"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayLayer = OverlayLayer;
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactPopper = require("react-popper");
var _useOverlayRoot3 = require("../_utils/hooks/useOverlayRoot");
var _mergeStyle = require("../_utils/mergeStyle");
var _callBoth = require("../_utils/callBoth");
var _Transition = require("../Transition");
var _useVisibleTransition2 = require("../_utils/hooks/useVisibleTransition");
var _injectValue = require("../_utils/injectValue");
var _configContext = require("../_utils/config-context");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var scaleOriginForPlacement = function (originMap) {
  return function (placement) {
    var basePlacement = placement.split('-').shift();
    return basePlacement ? originMap[basePlacement] : basePlacement;
  };
}({
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
});

/**
 * 为定位元素创建一个覆盖层
 *
 * @example
 *
  ```js
  const [visible, setVisible] = useState(false);
  const open = () => setVisible(true);
  const close = () => setVisible(false);
  <Overlay
    visible={visible}
    content={<div>我是浮层内容，<a onClick={close}>关闭</a></div>}
    children={ref => <a ref={ref} onClick={open}>点击弹出浮层</a>}
  />
  ```
 */
function OverlayLayer(_ref) {
  var content = _ref.content,
    _ref$overlayRef = _ref.overlayRef,
    overlayRef = _ref$overlayRef === void 0 ? function () {} : _ref$overlayRef,
    _ref$overlayProps = _ref.overlayProps,
    overlayProps = _ref$overlayProps === void 0 ? {} : _ref$overlayProps,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? false : _ref$visible,
    _ref$placementOffset = _ref.placementOffset,
    placementOffset = _ref$placementOffset === void 0 ? 5 : _ref$placementOffset,
    _ref$transitionTimeou = _ref.transitionTimeout,
    transitionTimeout = _ref$transitionTimeou === void 0 ? {
      enter: 50,
      exit: 300
    } : _ref$transitionTimeou,
    updateOnDimensionChange = _ref.updateOnDimensionChange,
    referenceElement = _ref.referenceElement,
    _ref$animationScaleFr = _ref.animationScaleFrom,
    animationScaleFrom = _ref$animationScaleFr === void 0 ? 0.94 : _ref$animationScaleFr,
    escapeWithReference = _ref.escapeWithReference,
    _ref$modifiers = _ref.modifiers,
    modifiers = _ref$modifiers === void 0 ? {} : _ref$modifiers;
  var _useConfig = (0, _configContext.useConfig)(),
    classPrefix = _useConfig.classPrefix;
  // visible 启动时，才开始渲染内容，进行动画
  var _useVisibleTransition = (0, _useVisibleTransition2.useVisibleTransition)(visible),
    shouldContentRender = _useVisibleTransition.shouldContentRender,
    shouldContentEnter = _useVisibleTransition.shouldContentEnter,
    onContentExit = _useVisibleTransition.onContentExit;
  var _useOverlayRoot = (0, _useOverlayRoot3.useOverlayRoot)(),
    _useOverlayRoot2 = (0, _slicedToArray2.default)(_useOverlayRoot, 1),
    overlayRoot = _useOverlayRoot2[0];
  if (!shouldContentRender) {
    return null;
  }

  // 渲染定位组件
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
    referenceElement: referenceElement,
    placement: placement,
    modifiers: _objectSpread({
      offset: {
        enabled: true,
        offset: Array.isArray(placementOffset) ? "".concat(placementOffset[0], ", ").concat(placementOffset[1]) : "0,".concat(placementOffset)
      },
      preventOverflow: {
        escapeWithReference: escapeWithReference,
        boundariesElement: 'viewport'
      },
      computeStyle: {
        // 使用 translate3d() 在 Windows 下有 DPI 缩放时会导致模糊
        // 只有在 resize 和 scroll 的时候才会有更新的需求，暂时关闭 GPU 加速
        gpuAcceleration: false
      }
    }, modifiers),
    eventsEnabled: updateOnDimensionChange,
    positionFixed: true
  }, function (popper) {
    var overlayContent = (0, _injectValue.injectValue)(content)(_objectSpread(_objectSpread({}, popper), {}, {
      visible: visible
    }));
    return /*#__PURE__*/_react.default.createElement(_Transition.ScaleTransition, {
      from: animationScaleFrom,
      origin: scaleOriginForPlacement(placement),
      timeout: transitionTimeout,
      in: shouldContentEnter,
      onEnter: function onEnter() {
        return popper.scheduleUpdate();
      },
      onExited: onContentExit
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, overlayProps, {
      // 覆盖层类名，样式表中包含 z-index 来确定覆盖层的层级
      className: (0, _classnames.default)("".concat(classPrefix, "-overlay"), overlayProps.className)
      // ref 同时提供给 popper 和 contentRef
      ,
      ref: (0, _callBoth.callBoth)(popper.ref, overlayRef)
      // popper.style 为 overlay 浮层提供定位
      // contentStyle 提供给用户改写的可能
      ,
      style: (0, _mergeStyle.mergeStyle)(popper.style, {
        willChange: undefined
      }, overlayProps.style ? overlayProps.style : {})
      // popper API 要求提供 data-placement
      ,
      "data-placement": popper.placement || placement
    }), /*#__PURE__*/_react.default.isValidElement(overlayContent) ? overlayContent : /*#__PURE__*/_react.default.createElement("span", null, overlayContent)));
  }), overlayRoot);
}
var _default = exports.default = OverlayLayer;